<section class="flex mb-6 flex-col">
    <div class="flex mb-7">
        <div class="flex-1 flex flex-col">
            <span class="span1 text-neutral-600 text-2xl font-semibold font-['Inter'] leading-normal">
                Ventas asociadas
            </span>
        </div> 
        @if (loader) {
            <div role="status" class="pr-4">
                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin fill-indigo-400" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                </svg>
            </div>
    
            <div class="text flex gap-2 text-indigo-400 text-[14px] font-semibold font-['Poppins'] leading-none tracking-tight " style="align-items: center;">
                Estamos cargando la información de tus ventas asociadas.
            </div>
        }
    </div>
    <div class="flex flex-col">
        <div class="borde-1 bg-white py-3 text-center shadow-1 mb-4 flex">
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Fecha y hora
            </span>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Monto de venta
            </span>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Comisión
            </span>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Monto a abonar
            </span>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Estado
            </span>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Medio de pago
            </span>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Tipo de tarjeta
            </span>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal">
                Detalle ventas
            </span>
        </div>

        @if (loader) {
            <p-dataView #dv [value]="transactionsLoading" [rows]="9" [paginator]="true">
                <ng-template #list let-transactionsLoading>
                    @for (item of transactionsLoading; track $index) {
                        <div class="borde-2 bg-white py-3 text-center items-center shadow-1 mb-2 flex">
                            <span class="loading px-3 flex-1 border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <span class="loading px-3 flex-1  border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <span class="loading px-3 flex-1  border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <span class="loading px-3 flex-1  border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <span class="loading px-3 flex-1  border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <span class="loading px-3 flex-1  border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <span class="loading px-3 flex-1  border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <span class="loading px-3 flex-1 ">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                        </div>
                    }
                    
                </ng-template>
            </p-dataView>
        } @else {
            <p-dataView #dv [value]="depositDetail" [rows]="9" [paginator]="true">
                <ng-template #list let-depositDetail>
                    @for (item of depositDetail; track item.id) {
                        <div class="borde-2 bg-white py-3 text-center items-center shadow-1 mb-2 flex">
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                {{ item.updated_at | date: 'dd-MM-yyyy - HH:mm:ss' }} Hrs.
                            </span>
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                {{ normalizeDataService.currencyFormat(item.amount) }}
                            </span>
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                {{ normalizeDataService.totalComission(item).text }}
                            </span>
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                {{ normalizeDataService.finalAmount(item).text }}
                            </span>
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                @switch (item.status) {
                                    @case ('succeeded') {
                                        <app-badges text="Aprobada"></app-badges>
                                    }
                                    @case ('SUCCESS') {
                                        <app-badges text="Aprobada"></app-badges>
                                    }
                                    @case ('processing') {
                                        <app-badges text="Cancelado" bgColor="bg-yellow-400"></app-badges>
                                    }
                                    @case ('error') {
                                        <app-badges text="Rechazado" bgColor="bg-red-500"></app-badges>
                                    }
                                    @case ('ERROR') {
                                        <app-badges text="Rechazado" bgColor="bg-red-500"></app-badges>
                                    }
                                }
                            </span>
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                <div class="inline-flex">
                                    @if(item.network == 'VISA'){
                                        <div class="inline-block rounded-sm items-center" style="display: flex; align-items: center;">
                                            <img class="w-[18px]" src="../../../assets/img/sales/ic-visa2.svg" />
                                        </div>
                                    } @else {
                                        <div class="inline-block rounded-sm items-center" style="display: flex; align-items: center;">
                                            <img class="w-[18px]" src="../../../assets/img/sales/ic-mastercard2.svg" />
                                        </div>
                                    }
                                    <span class="ms-1">{{ item.bin.slice(0, 4) + ' ' + item.bin.slice(4, 6) + 'XX' }} XXXX {{ item.lastfourdigit }}</span>
                                </div>
                            </span>
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                {{ normalizeDataService.creditCardType(item.type) }}
                            </span>
                            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Poppins'] leading-normal">
                                <a (mousedown)="handleMouseDown(item.channel, item.id, item.operation_type, $event)" (click)="handleClickChannel(item.channel, item.id, item.operation_type, $event)" [routerLink]="'/transacciones/' + item.id" class="text-indigo-400 text-[10px] font-medium font-['Poppins'] leading-none tracking-tight">
                                    Ver detalles
                                    <img class="inline ms-1" src="../../../assets/img/sales/ic-arrow-detalle.svg" />
                                </a>
                            </span>
                        </div>
                    }
                </ng-template>
            </p-dataView>
        }
    </div>
</section>

<section class="items-center flex">
    <a routerLink="/abonos" class="mx-auto w-60 px-[25px] py-[10px] bg-indigo-300 rounded-[14px] text-center items-center align-middle" style="position: fixed; bottom: 6%; left: 50%;">
        <span class="text-white font-semibold font-['Inter']">
            Volver
        </span>
    </a>
</section>